/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienHomeHeroData } from './obrien-home-hero.data';
import { IObrienHomeHeroProps } from './obrien-home-hero.props.autogenerated';

export interface IObrienHomeHeroViewProps extends IObrienHomeHeroProps<IObrienHomeHeroData> {
    obHeroTitle: React.ReactNode;
    obHeroImage: React.ReactNode;
    obHeroImageOverlay: React.ReactNode;
    obHeroId: string;
    obHeroContent: string;
    obHeroButtonLink: string;
    obHeroButtonText: string;
    imageContainer: INodeProps;

}

/**
 *
 * ObrienHomeHero component
 * @extends {React.PureComponent<IObrienHomeHeroProps<IObrienHomeHeroData>>}
 */
class ObrienHomeHero extends React.PureComponent<IObrienHomeHeroProps<IObrienHomeHeroData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { obHeroImage, obHeroImageOverlay } = this.props.config;

        const HeroTitle = config.obHeroTitle ? config.obHeroTitle : 'No Header Name Provided';

        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImage && obHeroImage.imageSettings,
        };

        const heroImage = obHeroImage && (
            <Msdyn365.Image {...obHeroImage} {...imageProps} editProps ={{key:this.props.config.obHeroImage || {}, requestContext: this.props.context.request}}/>
        );

        const imageOverlayProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obHeroImageOverlay && obHeroImageOverlay.imageSettings,
        };

        const heroImageOverlay = obHeroImageOverlay && (
            <Msdyn365.Image {...obHeroImageOverlay} {...imageOverlayProps} editProps ={{key:this.props.config.obHeroImageOverlay || {}, requestContext: this.props.context.request}}/>
        );

        //const HeroImage = config.obHeroImage ? config.obHeroImage.src : '';
        const HeroId = config.obHeroId ? config.obHeroId : 'No Id';
        const HeroContent = config.obHeroContent ? config.obHeroContent : '';
        const HeroButtonLink = config.obHeroButtonLink ? config.obHeroButtonLink : '#';
        const HeroButtonText = config.obHeroButtonText ? config.obHeroButtonText : 'No Text';
        const ObrienHomeHeroProps = {
            ...this.props,
            obHeroTitle: HeroTitle,
            obHeroImage: heroImage,
            obHeroImageOverlay: heroImageOverlay,
            obHeroId: HeroId,
            obHeroContent: HeroContent,
            obHeroButtonLink: HeroButtonLink,
            obHeroButtonText: HeroButtonText,
            imageContainer: {},
        };

        return this.props.renderView(ObrienHomeHeroProps);
    }
}

export default ObrienHomeHero;
